export default {
  category: {
    id: "landing",
    label: "Landing Page",
  },
};
